module.exports = __webpack_public_path__ + "media/images/statistics2-970dafe93838534653fdb42a648eecd1.jpg";